import Configuration from "./../../config";
import { getTZ } from "./../formElements/TimeZone/services/timeZoneUtil";
import { getLatLng } from "react-places-autocomplete";
import { logInfo } from "./../../services/logging";
import * as _ from "underscore";

interface Address {
  city?: string;
  state?: string;
  country?: string;
  street1?: string;
  zipcode?: string;
}

interface Timezone {
  utc_offset: string;
  id: string;
}

interface TimeZoneResponse {
  dstOffset: number;
  rawOffset: number;
  status: string;
  timeZoneId: string;
  timeZoneName: string;
}

const API_KEY = Configuration.GOOGLE_API_KEY;

export function transformLocationResults(
  newAddr: Address,
  results: google.maps.GeocoderResult[]
): Promise<google.maps.LatLngLiteral> {
  _.each(results, r => {
    _.each(r.address_components, c => {
      if (c.types && c.types.includes("political")) {
        if (
          c.types.includes("locality") ||
          c.types.includes("administrative_area_level_3")
        ) {
          newAddr.city = c.long_name;
        }
        if (c.types.includes("administrative_area_level_1")) {
          newAddr.state = c.long_name;
        }
        if (c.types.includes("country")) {
          newAddr.country = c.long_name;
          if (!newAddr.city) {
            newAddr.city = c.long_name.toUpperCase();
          }
        }
      } else if (c.types.includes("route")) {
        newAddr.street1 = newAddr.street1
          ? newAddr.street1 + " " + c.long_name
          : c.long_name;
      } else if (c.types[0] === "street_number") {
        newAddr.street1 = newAddr.street1
          ? c.long_name + " " + newAddr.street1
          : c.long_name;
      } else if (c.types[0] === "postal_code") {
        newAddr.zipcode = c.long_name;
      } else if (c.types[0] === "postal_code_suffix") {
        // newPlace.name.street1 = c.long_name
      }
    });
  });
  return getLatLng(results[0]);
}

export function getTimezone(
  latLng: google.maps.LatLngLiteral,
  callback?: (timezone: Timezone) => void
): Promise<Timezone> {
  return fetch(
    `https://maps.googleapis.com/maps/api/timezone/json?location=${latLng.lat}%2C${latLng.lng}&timestamp=${Date.now() / 1000}&key=${API_KEY}`
  )
    .then(res => res.json())
    .then((result: TimeZoneResponse) => {
      const tz = getTZ(result.timeZoneId);
      const timezone: Timezone = {
        utc_offset: tz,
        id: result.timeZoneId,
      };
      callback?.(timezone);
      return timezone;
    })
    .catch(function (err: Error) {
      logInfo("error when changing location", {
        from: "WrongTimezoneWarning#getTimezone",
        error: err,
      });
      throw err;
    });
}
